@if (user) {
  <bst-dual-axis [delegate]="this" [bootstrap]="true" [height]="'200px'"></bst-dual-axis>
}

<ng-template #cellTemplate let-uclient="row" let-column="column" let-node="node">
  @switch (column.name) {
    @case ('name') {
      <div>
        <nb-user shape="rectangle" [class.hasurl]="uclient.client.url" (click)="selectClient(uclient.client)" [name]="uclient.client.name" [title]="uclient.client.address" color="#eee" [picture]="uclient.client.logo ? uclient.client.logo : null"></nb-user>
      </div>
    }
    @case ('description') {
      <span>
        {{ uclient.client.description }}
      </span>
    }
    @case ('active') {
      <div [nbTooltip]="isCurClient(uclient.client) ? ('curcompany' | translate) : ('anothercompany' | translate)">
        @if (isCurClient(uclient.client)) {
          <nb-checkbox [disabled]="true" [checked]="user && uclient.client.id === user.client.id"></nb-checkbox>
        }
        @if (!isCurClient(uclient.client)) {
          <button nbButton status="primary" size="small" (click)="setClient(uclient.client)">{{ 'set' | translate }}</button>
        }
      </div>
    }
    @case ('status') {
      <span [class]="'ustatus_' + uclient.status">
        {{ 'userstatus.' + uclient.status | translate }}
      </span>
    }
    @case ('start_on') {
      <span>
        {{ uclient.start_on | date:'longDate' }}
      </span>
    }
    @case ('end_on') {
      <span>
        {{ uclient.end_on | date:'longDate' }}
      </span>
    }
  }
</ng-template>
